import axios from 'axios';
import { API } from 'configs/api';

export const settingsService = {
  updateAccount: (newUserForm) => axios.put(API.user, newUserForm, { token: true }),
  updateUserAvatar: (formData) =>
    axios.post(API.updateAvatar, formData, { token: true }),
  changePassword: (newPasswordForm) =>
    axios.post(API.changePassword, newPasswordForm, { token: true }),
  deleteAccount: (reasonForm) =>
    axios.delete(API.user, { token: true, data: reasonForm }),
  getCountries: () => axios.get(API.getCountries, { token: true }),
  getCities: (cityId) =>
    axios.get(`${API.country}/${cityId}${API.cities}`, { token: true }),
};
